import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, Flame } from 'lucide-react';
export function Pricing() {
  const includes = ['Recetario Digital Completo (PDF)', 'Plan de Comidas de 30 Días', 'Listas de Compras Semanales', 'Guía de Alimentos Permitidos y Prohibidos', 'Acceso Inmediato de por Vida'];
  return <section id="pricing" className="py-20 bg-brand-primary text-white" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-130">
            Comienza tu recuperación hoy mismo
          </h2>
          <p className="text-lg text-brand-bg/80" data-id="element-131">
            Oferta especial por tiempo limitado. No dejes pasar esta
            oportunidad.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-md mx-auto mt-10 rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white/10" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/bEULSCjFMGafYDexigYMSS/Copilot_20260616_193057.png" alt="Mockup del recetario digital 'Recetas Deliciosas para Hígados Sanos' en tablet, celular y guía impresa junto a ingredientes saludables." className="w-full h-auto object-cover" loading="lazy" data-id="element-133" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden max-w-2xl mx-auto" data-id="element-134">
          <div className="bg-brand-accent text-white py-3 px-6 text-center flex items-center justify-center gap-2 font-bold" data-id="element-135">
            <Flame className="w-5 h-5" data-id="element-136" />
            <span data-id="element-137">Precio especial de lanzamiento</span>
          </div>

          <div className="p-8 md:p-12" data-id="element-138">
            <div className="flex justify-between items-start mb-8" data-id="element-139">
              <div data-id="element-140">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-141">
                  Acceso Total
                </h3>
                <p className="text-gray-500" data-id="element-142">
                  Todo incluido para apoyar tu bienestar
                </p>
              </div>
              <div className="text-right" data-id="element-143">
                <div className="inline-block bg-red-100 text-red-600 font-bold px-3 py-1 rounded-full text-sm mb-2" data-id="element-144">
                  75% OFF
                </div>
                <div className="text-gray-400 line-through text-lg" data-id="element-145">
                  Precio normal: $64
                </div>
                <div className="text-5xl font-extrabold text-brand-primary flex items-start justify-end" data-id="element-146">
                  <span className="text-2xl mt-1" data-id="element-147">$</span>16
                </div>
              </div>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-148">
              {includes.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-149">
                  <div className="bg-brand-primary/10 rounded-full p-1" data-id="element-150">
                    <Check className="w-4 h-4 text-brand-primary" strokeWidth={3} data-id="element-151" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-152">{item}</span>
                </li>)}
            </ul>

            <a href="https://noveliahub.com/cart/50878318477348:1" className="w-full bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-5 px-8 rounded-2xl shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-orange-400/60 animate-pulse flex justify-center items-center gap-2" data-id="element-153">
              Sí, quiero acceso inmediato
            </a>
            <p className="text-center text-sm text-gray-500 mt-4" data-id="element-154">
              Pago único y seguro. Acceso instantáneo al material.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}